module.exports = __webpack_public_path__ + "img/spartan-carpentry-millwork-cabinetry-07-square.fc4162cc.jpg";